/**
 * Hero section: header scroll visibility on index page
 * Hides header when hero is in view (top 90% of viewport)
 */
(function() {
  function run(retry) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() { run(0); });
      return;
    }
    var w = document.getElementById('header-scroll-wrapper');
    if (!w || !w.classList.contains('header-scroll-wrapper--index')) return;

    var heroSection = document.getElementById('shopify-section-hero-video-section');
    if (!heroSection) {
      if (retry < 20) {
        setTimeout(function() { run(retry + 1); }, 50);
        return;
      }
      w.classList.remove('header-scroll-wrapper--hero-first', 'header-scroll-wrapper--hidden');
      return;
    }

    var SCROLL_BUFFER = 48;
    var navResetInProgress = false;
    var rafPending = false;

    /* Theme openMobileNav() pushes #PageContainer down — animate back (no snap). */
    function resetThemeMobileNavForHero() {
      if (navResetInProgress) return;

      var pageContainer = document.getElementById('PageContainer');
      var mobileNav = document.querySelector('.mobile-nav-wrapper');
      var toggle = document.querySelector('.js-mobile-nav-toggle');
      var menuOpen = mobileNav && mobileNav.classList.contains('js-menu--is-open');
      var pageShifted = pageContainer && pageContainer.style.transform;

      if (!menuOpen && !pageShifted) return;

      navResetInProgress = true;

      if (window.theme && theme.Helpers && theme.Helpers.prepareTransition) {
        if (mobileNav) theme.Helpers.prepareTransition(mobileNav);
        if (pageContainer) theme.Helpers.prepareTransition(pageContainer);
      }

      if (mobileNav) {
        mobileNav.classList.remove('js-menu--is-open');
        mobileNav.style.transform = 'translateY(-100%)';
      }

      if (toggle) {
        toggle.classList.remove('mobile-nav--close');
        toggle.classList.add('mobile-nav--open');
        toggle.setAttribute('aria-expanded', 'false');
      }

      function finishPageReset() {
        if (!pageContainer) {
          navResetInProgress = false;
          return;
        }
        pageContainer.classList.remove('hero-page-reset');
        pageContainer.removeAttribute('style');
        navResetInProgress = false;
      }

      if (pageShifted) {
        pageContainer.classList.add('hero-page-reset');
        pageContainer.style.transform = 'translate3d(0, 0, 0)';

        var onEnd = function (e) {
          if (e && e.target !== pageContainer) return;
          pageContainer.removeEventListener('transitionend', onEnd);
          finishPageReset();
        };
        pageContainer.addEventListener('transitionend', onEnd);
        setTimeout(function () {
          if (navResetInProgress) onEnd({ target: pageContainer });
        }, 480);
      } else {
        navResetInProgress = false;
      }
    }

    function shouldHideHeader(scrollY, heroHeight, currentlyHidden) {
      if (currentlyHidden) {
        return scrollY < heroHeight + SCROLL_BUFFER;
      }
      return scrollY < heroHeight - SCROLL_BUFFER;
    }

    function applyUpdate() {
      if (document.body.classList.contains('js-drawer-open-top')) return;

      var scrollY = window.scrollY || document.documentElement.scrollTop;
      var heroHeight = heroSection.offsetHeight || window.innerHeight;
      var currentlyHidden = w.classList.contains('header-scroll-wrapper--hidden');
      var hideHeader = shouldHideHeader(scrollY, heroHeight, currentlyHidden);
      var pageContainer = document.getElementById('PageContainer');

      /* Stuck transform while header already hidden (e.g. fast scroll) */
      if (hideHeader && pageContainer && pageContainer.style.transform && !navResetInProgress) {
        resetThemeMobileNavForHero();
      }

      if (hideHeader === currentlyHidden) return;

      w.classList.toggle('header-scroll-wrapper--hidden', hideHeader);
      if (hideHeader) resetThemeMobileNavForHero();
    }

    function update() {
      if (rafPending) return;
      rafPending = true;
      requestAnimationFrame(function () {
        rafPending = false;
        applyUpdate();
      });
    }

    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', function () {
      update();
    });
  }
  run(0);
})();

/**
 * Hero sticky: section sticks at top on scroll, then next section scrolls over it.
 * Uses spacer + fixed when stuck. Disabled on mobile to avoid spacer white space.
 */
(function() {
  function run(retry) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() { run(0); });
      return;
    }
    var section = document.getElementById('shopify-section-hero-video-section');
    if (!section || !document.body.classList.contains('template-index')) return;

    var spacer = null;
    var lastStuck = false;
    var stuckSpacerHeight = 0; /* keep spacer at original hero height when stuck */
    var mobileMaxWidth = 768;

    function isMobile() {
      return window.innerWidth <= mobileMaxWidth;
    }

    function update() {
      if (isMobile()) {
        if (lastStuck) {
          lastStuck = false;
          stuckSpacerHeight = 0;
          section.classList.remove('hero-video-section--stuck');
          var heroInner = section.querySelector('.hero-video') || section.querySelector('[data-hero-video-section]');
          if (heroInner) heroInner.classList.remove('hero-video-section--stuck');
          if (spacer && spacer.parentNode) spacer.parentNode.removeChild(spacer);
          spacer = null;
        }
        return;
      }

      var scrollY = window.scrollY || document.documentElement.scrollTop;
      var sectionHeight = section.offsetHeight;
      var stickThreshold = sectionHeight - 1;

      if (scrollY >= stickThreshold) {
        if (!lastStuck) {
          lastStuck = true;
          stuckSpacerHeight = sectionHeight;
          /* Insert spacer FIRST so layout doesn’t jump when hero goes fixed */
          if (!spacer) {
            spacer = document.createElement('div');
            spacer.className = 'hero-video-section-spacer';
            spacer.setAttribute('aria-hidden', 'true');
            spacer.style.height = stuckSpacerHeight + 'px';
            section.parentNode.insertBefore(spacer, section.nextSibling);
          }
          section.classList.add('hero-video-section--stuck');
          var heroInner = section.querySelector('.hero-video') || section.querySelector('[data-hero-video-section]');
          if (heroInner) heroInner.classList.add('hero-video-section--stuck');
        } else {
          spacer.style.height = stuckSpacerHeight + 'px';
        }
      } else {
        if (lastStuck) {
          lastStuck = false;
          stuckSpacerHeight = 0;
          section.classList.remove('hero-video-section--stuck');
          var heroInner = section.querySelector('.hero-video') || section.querySelector('[data-hero-video-section]');
          if (heroInner) heroInner.classList.remove('hero-video-section--stuck');
          if (spacer && spacer.parentNode) spacer.parentNode.removeChild(spacer);
          spacer = null;
        }
      }
    }

    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
  }
  run(0);
})();
